module.exports = __webpack_public_path__ + "static/media/module-bg.c4a9c258.png";